import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
function Card(props) {
  const [imgState, setimgState] = useState(props.img);
  return (
    <div className="w-100 p-2 h-100 ">
      <img
        onMouseEnter={() => {
          setimgState(props.imgUrl2);
        }}
        onMouseLeave={() => {
          setimgState(props.img);
        }}
        src={imgState}
        alt=""
      />
      <div className="card_details">
        <h4 className="mt-3 text-sm">{props.title}</h4>
        <Link to="#">
          {" "}
          <p className="text-xs mt-2">Shop Now</p>
        </Link>
      </div>
    </div>
  );
}

export default Card;
